export const contingentProgressCircleIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M1.96 16.5A10.953 10.953 0 011 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11a10.96 10.96 0 01-6.982-2.499" stroke="#1ABC9C" stroke-width="2" stroke-miterlimit="10"/></svg>`,
  name: 'progress-circle',
};
